import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "./context/AuthContext";
import ProtectedRoute from "./components/admin/ProtectedRoute";
import useBrandIdentity from "./hooks/useBrandIdentity";

import PublicHome from "./pages/public/PublicHome";
import ProductsList from "./pages/public/ProductsList";
import ProductDetail from "./pages/public/ProductDetail";
import BlogsList from "./pages/public/BlogsList";
import BlogDetail from "./pages/public/BlogDetail";
import CareersList from "./pages/public/CareersList";
import CareerDetail from "./pages/public/CareerDetail";
import ContactUs from "./pages/public/ContactUs";
import AboutPage from "./pages/public/AboutPage";
import AdminLogin from "./pages/admin/Login";
import Dashboard from "./pages/admin/Dashboard";
import Products from "./pages/admin/Products";
import Categories from "./pages/admin/Categories";
import Blogs from "./pages/admin/Blogs";
import Inquiries from "./pages/admin/Inquiries";
import Careers from "./pages/admin/Careers";
import Applications from "./pages/admin/Applications";
import Clients from "./pages/admin/Clients";
import Sliders from "./pages/admin/Sliders";
import Sections from "./pages/admin/Sections";
import Media from "./pages/admin/Media";
import Users from "./pages/admin/Users";
import Settings from "./pages/admin/Settings";
import SeoSettings from "./pages/admin/SeoSettings";
import Redirects from "./pages/admin/Redirects";
import Faqs from "./pages/admin/Faqs";
import Testimonials from "./pages/admin/Testimonials";
import Videos from "./pages/admin/Videos";
import VideosList from "./pages/public/VideosList";

const Protected = ({ children }) => <ProtectedRoute>{children}</ProtectedRoute>;

function App() {
  useBrandIdentity();
  return (
    <AuthProvider>
      <BrowserRouter>
        <Toaster position="top-right" richColors />
        <Routes>
          <Route path="/" element={<PublicHome />} />
          <Route path="/about" element={<AboutPage />} />
          <Route path="/products" element={<ProductsList />} />
          <Route path="/products/:slug" element={<ProductDetail />} />
          <Route path="/blogs" element={<BlogsList />} />
          <Route path="/blogs/:slug" element={<BlogDetail />} />
          <Route path="/careers" element={<CareersList />} />
          <Route path="/careers/:slug" element={<CareerDetail />} />
          <Route path="/contact" element={<ContactUs />} />
          <Route path="/videos" element={<VideosList />} />
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route path="/admin" element={<Protected><Dashboard /></Protected>} />
          <Route path="/admin/products" element={<Protected><Products /></Protected>} />
          <Route path="/admin/categories" element={<Protected><Categories /></Protected>} />
          <Route path="/admin/blogs" element={<Protected><Blogs /></Protected>} />
          <Route path="/admin/faqs" element={<Protected><Faqs /></Protected>} />
          <Route path="/admin/inquiries" element={<Protected><Inquiries /></Protected>} />
          <Route path="/admin/careers" element={<Protected><Careers /></Protected>} />
          <Route path="/admin/applications" element={<Protected><Applications /></Protected>} />
          <Route path="/admin/clients" element={<Protected><Clients /></Protected>} />
          <Route path="/admin/testimonials" element={<Protected><Testimonials /></Protected>} />
          <Route path="/admin/sliders" element={<Protected><Sliders /></Protected>} />
          <Route path="/admin/videos" element={<Protected><Videos /></Protected>} />
          <Route path="/admin/sections" element={<Protected><Sections /></Protected>} />
          <Route path="/admin/media" element={<Protected><Media /></Protected>} />
          <Route path="/admin/users" element={<Protected><Users /></Protected>} />
          <Route path="/admin/settings" element={<Protected><Settings /></Protected>} />
          <Route path="/admin/seo" element={<Protected><SeoSettings /></Protected>} />
          <Route path="/admin/redirects" element={<Protected><Redirects /></Protected>} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
